import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import useResizeObserver from 'use-resize-observer';

import AddressBar from './AddressBar';
import Disclaimer from '../ProductLineDisclaimer';
import EmbeddedGoogleMap from '../EmbeddedGoogleMap/index';
import ToggleViewContainer from './ToggleViewContainer';
import formatAddress from '../../utils/formatAddress';
import themeStyles from './MobileLayout.styles';
import usePlaceFromCookie from '../../hooks/usePlaceFromCookie';
import useRedirectToLeadClient from '../../hooks/useRedirectToLeadClient';
import { DealersListContext } from '../DealersListContext';

const Container = themeStyles.apply(Box, 'Container');

const MobileLayout = ({ variant }) => {
  const { ref: disclaimerRef, height: disclaimerHeight } = useResizeObserver();

  const [isFullScreenModal, setFullScreenModal] = useState(false);
  const {
    selectedPlace,
    isOpen,
    setIsOpen,
    setSelectedPlace,
    inputValue,
    setInputValue,
    setSelectedDealer,
    isDealerModalOpen,
  } = useContext(DealersListContext);
  const address = formatAddress(selectedPlace);

  useRedirectToLeadClient();
  usePlaceFromCookie();

  const { t } = useTranslation();
  const buttonLabel = selectedPlace
    ? t('Sub-apps.Dealers.locationEditButton')
    : t('Sub-apps.Dealers.locationAddButton');
  const locationLabel = selectedPlace ? address : t('Sub-apps.Dealers.enterLocationLabel');

  return (
    <Container isFullScreenModal={isFullScreenModal || isDealerModalOpen} data-testid="cy-dealer-locator">
      <Box ref={disclaimerRef}>
        <Optional when={!isDealerModalOpen}>
          <AddressBar
            locationLabel={locationLabel}
            buttonLabel={buttonLabel}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            setSelectedDealer={setSelectedDealer}
            setSelectedPlace={setSelectedPlace}
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
          <Disclaimer />
        </Optional>
      </Box>
      {selectedPlace ? (
        <ToggleViewContainer
          isFullScreenModal={isFullScreenModal}
          setFullScreenModal={setFullScreenModal}
          variant={variant}
          disclaimerHeight={disclaimerHeight}
        />
      ) : (
        <EmbeddedGoogleMap width="100%" />
      )}
    </Container>
  );
};

MobileLayout.propTypes = {
  variant: PropTypes.string,
};

export default MobileLayout;
